import React, { useState } from 'react';
import { Typography, IconButton, Link, Tooltip } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { getCloudfrontUrl } from '@/utils/cloudfront';
import { StyledBox, StyledBoxOverlay } from './styles';

type Props = {
  name: string;
  uploadedOn: string;
  fileUrl: string;
};

export const UploadedFileCard = ({ name, uploadedOn, fileUrl }: Props) => {
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  return (
    <StyledBox onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <img src="/assets/csv_thumbnail_sample.png" alt="Preview" width={100} height={200} />
      <Tooltip title={<Typography fontSize="1.4rem">{name}</Typography>}>
        <Typography
          component="h1"
          sx={{
            fontSize: '2.4rem',
            fontWeight: 500,
            color: 'text.primary',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          {name}
        </Typography>
      </Tooltip>
      <Typography variant="body1" color="action.selected" fontSize="1.4rem" mb={2}>
        Uploaded on {uploadedOn}
      </Typography>
      {hovered && (
        <StyledBoxOverlay>
          <Link href={getCloudfrontUrl(fileUrl)}>
            <IconButton sx={{ color: 'primary.darkBlue' }}>
              <FileDownloadOutlinedIcon sx={{ fontSize: '4rem' }} />
            </IconButton>
          </Link>
        </StyledBoxOverlay>
      )}
    </StyledBox>
  );
};
